import { SpacingTokens } from '@bonanza-social/moonlight';

export const GRID_GAP: SpacingTokens = 'space-200';
export const DEFAULT_GRID_OFFSET_X: SpacingTokens = 'space-600';
